if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.makeStartWith
) {
  Object.defineProperty(String.prototype, 'makeStartWith', {
    value(start) {
      return this.startsWith(start) ? this : `${start}${this}`;
    }
  });
}